/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BusinessIdeaFields {
	Name = "Name",
	Description = "Description",
	FirstVisit = "FirstVisit",
	Municipality = "Municipality",
	Startuppers = "Startuppers",
	BusinessPremiseRequirement = "BusinessPremiseRequirement",
	BusinessFieldGroup = "BusinessFieldGroup",
	BusinessField = "BusinessField",
	Tol2008 = "Tol2008",
	EmploymentClassification = "EmploymentClassification",
	EmploymentDescription = "EmploymentDescription",
	WorkExperienceDescription = "WorkExperienceDescription",
	IsFullTime = "IsFullTime",
	EducationClassification = "EducationClassification",
	EducationDescription = "EducationDescription",
	Schools = "Schools",
	HeardFromUs = "HeardFromUs",
	HeardFromUsWhere = "HeardFromUsWhere",
	BusinessIdeaType = "BusinessIdeaType",
	IsContinuer = "IsContinuer",
	EmploysTotal = "EmploysTotal",
	EmploysEntrepreneurs = "EmploysEntrepreneurs",
	EmploysFullTime = "EmploysFullTime",
	EmploysPartTime = "EmploysPartTime",
	EmploysJobSearchers = "EmploysJobSearchers",
	EmploysWomen = "EmploysWomen",
	EmploysYouth = "EmploysYouth",
	CompanyName = "CompanyName",
	NetboxSearch = "NetboxSearch",
}
